module.exports = __webpack_public_path__ + "static/media/Unsuccessful.f3f0c7bf.svg";